import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import { sync, SYNC } from 'shared/wizard/actions';
import { SplitDate, RadioSwitch } from 'shared/inputs';
import { InputsContainer } from 'shared/containers';
import { Heading, LabelText, Info } from 'shared/components';
import analytics from 'shared/utility/analytics';

const PartnerForm = () => {
  const dispatch = useDispatch();
  const {
    output: { errors },
    input,
  } = useSelector(state => state);

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false });
    analytics.send('Navigeer', 'Partner Pagina');
  }, []);

  return (
    <>
      <Heading>Je partner</Heading>
      <InputsContainer>
        <LabelText>Wil je je partner meeverzekeren?</LabelText>
        <RadioSwitch
          name="exists"
          onChangeHandler={sync(dispatch)('has_partner')}
          checked={input.has_partner}
          errors={errors.has_partner}
        />
        {input.has_partner && (
          <>
            <LabelText>Geboortedatum partner</LabelText>
            <SplitDate
              name="dob"
              onChange={dateObj => sync(dispatch)('partner_dob', dateObj)}
              value={input.partner_dob}
              errors={errors.partner_dob}
            />
            <LabelText>
              Rookt je partner?
              <Info title="Roken">
                Roken doet iets met je gezondheid. Rokers betalen daarom meestal meer premie dan niet-rokers. Heb je
                gerookt, maar ben je gestopt? De meeste verzekeraars gaan er van uit dat je pas twee jaar na je laatste
                sigaret definitief bent gestopt.
              </Info>
            </LabelText>
            <RadioSwitch
              name="partner_smokes"
              onChangeHandler={() => sync(dispatch)('partner_smokes', !input.partner_smokes)}
              checked={input.partner_smokes}
              errors={errors.partner_smokes}
            />
          </>
        )}
      </InputsContainer>
    </>
  );
};

export default PartnerForm;
